
import { Language } from "@vw-marketing/vw-ca-types";
import trans from "../trans";
import { useFeatureServices } from "../use-feature-services";

const useTrans = (lang?: Language) => {

  const featureServices = useFeatureServices();
  const { 'locale-service': localeService } = featureServices;

  if (lang) {
    return trans(lang);
  }

  return trans(localeService.language as unknown as Language);
}

export default useTrans;
